export const OnsiteInterviewsTabView = () => {
  return <div>Onsite Interviews</div>;
};
